import { formatRuntime } from '#helpers/formatRuntime.ts';
import { RangeSlider } from '../../Form/RangeSlider/index.tsx';
import { type Props } from './types.ts';

export const RuntimeRangeSlider = ({ ariaLabelledBy, disabled, name, onChange, value }: Props) => {
  const formatValueLabel = (val: number) => formatRuntime(val);
  const formatAriaValueText = (val: number) => `Runtime of ${String(val)}`;

  const handleOnChange = (event: Event, val: number | number[], activeThumb: number) => {
    onChange(event, val, activeThumb);
  };

  return (
    <RangeSlider
      ariaLabelledBy={ariaLabelledBy}
      disabled={disabled}
      formatAriaValueText={formatAriaValueText}
      formatValueLabel={formatValueLabel}
      getAriaLabel={() => 'Select vote average range'}
      marks={[
        { label: '0', value: 0 },
        { label: '1', value: 60 },
        { label: '2', value: 120 },
        { label: '3', value: 180 },
        { label: '4', value: 240 },
        { label: '5', value: 300 },
      ]}
      max={300}
      min={0}
      name={name}
      onChange={handleOnChange}
      step={15}
      sx={{
        '.MuiSlider-markLabel': {
          color: theme => theme.palette.grey[400],
        },
        '.MuiSlider-markLabelActive': {
          color: theme => theme.palette.grey[100],
        },
        marginLeft: theme => theme.spacing(1),
        width: theme => `calc(100% - ${theme.spacing(2)})`,
      }}
      value={value}
      valueLabelDisplay="auto"
    />
  );
};
